import { useState, useRef, useEffect } from "react";
import SelectAvatar from "./SelectAvatar";
import { supabase } from "../../supabase/client";
import { useUser } from "../../context/Usercontext";
import Button from "../../minicomponents/Button";

let SignUp = () => {
  let [fullName, setFullName] = useState("");
  let [email, setEmail] = useState("");
  let [pass, setPass] = useState("");
  let [username, setUsername] = useState("");
  let [profilePic, setProfilePic] = useState("");
  let [existError, setExistError] = useState(false);

  let selectPic = (e) => {
    setProfilePic(e.target.value);
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    setExistError(false);
    //VALIDATE FORM

    //FETCH EVERY

    try {
      const { data, error } = await supabase.auth.signUp({
        email: email,
        password: pass,
        options: {
          data: {
            full_name: fullName,
            username: username,
            profile_pic: profilePic,
          },
        },
      });
      setExistError(false);
      console.log(data);
      console.log("Success");
      if (!data.user) {
        setExistError(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form className="sign-up-form own-form" onSubmit={handleSubmit}>
      <div className="single-form-element">
        <label htmlFor="name1">Introduce your full name</label>
        <input
          id="name1"
          type="text"
          placeholder="John Doe"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />
      </div>
      <div className="single-form-element">
        <label htmlFor="email1">Introduce your email</label>
        <input
          id="email1"
          type="email"
          placeholder="email@example.com"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="single-form-element single-form-element-special">
        <label htmlFor="password">Set a password</label>
        <input
          id="password"
          type="password"
          placeholder="random157"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          title="Must contain at least one  number and one uppercase and lowercase letter, and at least 8 or more characters"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
        />
      </div>
      <div className="single-form-element single-form-element-special">
        <label htmlFor="username">Set a username</label>
        <input
          id="username"
          type="text"
          placeholder="john66doe"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>
      <div className="single-form-element">
        <label>Select your avatar</label>
      </div>
      <SelectAvatar
        profilePic={profilePic}
        setProfilePic={setProfilePic}
        selectPic={selectPic}
      />
      {existError ? (
        <span style={{ color: "red" }}>Por favor, revisa tus datos</span>
      ) : null}
      <Button buttonStyle={"button-style-1 button-width-100"}>Submit</Button>
    </form>
  );
};

export default SignUp;
